import { Borders, Row, Workbook, Worksheet } from "exceljs"
import { DataType } from "../../types"
import { dropdownAverage, itemBarcode } from "../.."

type ExportExcel = {
  data: DataType
  companyName?: string
}

export const exportExcel = async ({ data }: ExportExcel) => {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = [
    "COMPANY CODE",
    "COMPANY NAME",
    "SUBDOMAIN",
    "EMAIL",
    "PHONE",
    "MOBILE",
    "WEBSITE",
    "COUNTRY",
    "PROVINCE",
    "REGENCY",
    "SUBDISTRICT",
    "VILLAGE",
    "ADDRESS",
    "FINANCE YEAR",
    "METODE AVERAGE PRICE",
    "TYPE BARCODE",
  ]
  worksheet.views = [{ showGridLines: false }]

  worksheet.mergeCells(2, 1, 1, columns.length)

  // Title
  makeTitle(worksheet)

  // Header
  const headers = worksheet.addRow(columns)
  headers.font = { bold: true }
  headers.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF8C308" },
    }
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } },
    }
  })

  makeRows(data, worksheet)

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "setting-company.xlsx"
    a.click()
    URL.revokeObjectURL(url)
  })
}

function makeTitle(worksheet: Worksheet) {
  const titleCell = worksheet.getCell(1, 2)
  titleCell.value = "SETTING COMPANY"
  titleCell.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  }
  titleCell.font = { bold: true, size: 15 }

  worksheet.getColumn(2).width = 20
}

function makeRows(data: ExportExcel["data"], worksheet: Worksheet) {
  let itemRow: Row

  const cellBorder: Partial<Borders> = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } },
  }

  itemRow = worksheet.addRow([
    data.company_code,
    data.company_name,
    data.subdomain,
    data.email,
    data.phone,
    data.mobile_phone,
    data.website,
    data.country_name,
    data.province_name,
    data.regency_name,
    data.subdistrict_name,
    data.village_name,
    data.address,
    data.finance_year,
    data.methode_avg_price ? dropdownAverage?.find((item) => item.value === data.methode_avg_price)?.label : "",
    data.barcode_type ? itemBarcode?.find((item) => item.value === data.barcode_type)?.label : "",
  ])

  itemRow.eachCell((cell) => {
    cell.border = cellBorder
  })
}
